<template>
  <main class="g-box">
    <div class="tabs">
      <div role="tablist">
        <h2>
          <button id="area" role="tab" aria-selected="true" aria-controls="area-tab">
            <span class="g-clip">{{ $t("Home.search01") }}</span>
            <img class="g-pc" :src="this.$i18n.locale == 'en' ? '/img/h-from-area-en.svg' : '/img/h-from-area.svg'" :width="this.$i18n.locale == 'en' ? 132 : 263" alt="">
            <img class="g-sp" :src="this.$i18n.locale == 'en' ? '/img/h-from-area-en.png' : '/img/h-from-area.png'" alt="">
          </button>
        </h2>
        <h2>
          <button id="index" role="tab" aria-selected="false" aria-controls="index-tab" tabindex="-1">
            <span class="g-clip">{{ $t("Home.search02") }}</span>
            <img class="g-pc" :src="this.$i18n.locale == 'en' ? '/img/h-from-index-en.svg' : '/img/h-from-index.svg'" :width="this.$i18n.locale == 'en' ? 129 : 181" alt="">
            <img class="g-sp" :src="this.$i18n.locale == 'en' ? '/img/h-from-index-en.png' : '/img/h-from-index.png'" alt=""></button>
        </h2>
      </div>
      <div id="area-tab" tabindex="0" role="tabpanel" aria-labelledby="area">
        <div v-swiper:Swiper="swiperOption">
          <ul class="areaList swiper-wrapper">
            <li class="swiper-slide" v-for="topic in this.topicList" :key="topic.id"><router-link :to="topic.link"><img :src="topic.image" alt=""><span>{{ topic.name }}</span></router-link></li>
          </ul>
        </div>
        <div class="areaListArea_prev"></div>
        <div class="areaListArea_next"></div>
      </div>
      <div id="index-tab" tabindex="0" role="tabpanel" aria-labelledby="index" hidden>
        <indexList :indexList="this.indexList"></indexList>
      </div>
    </div>
    <div class="blocks g-clearfix">
      <section class="block search">
        <h2 class="block_h">
          <i class="g-i g-i-search" aria-hidden="true"></i>
          <span class="g-clip">{{ $t("Home.icchi_header") }}</span>
          <img class="g-pc" :src="this.$i18n.locale == 'en' ? '/img/h-search-en.svg' : '/img/h-search.svg'" :width="this.$i18n.locale == 'en' ? 276 : 134" alt="">
          <img class="g-sp" :src="this.$i18n.locale == 'en' ? '/img/h-search-en.png' : '/img/h-search.png'" alt="">
        </h2>
        <form class="block_body" @submit.prevent="searchObject">
          <dl class="formList">
            <dt>{{ $t("Form.fulltext") }}</dt>
            <dd>
              <input class="g-input g-input-lg" type="text" v-model="searchRequest.fulltext">
            </dd>
            <dt>{{ $t("Form.dbs") }}</dt>
            <dd>
              <Select2 v-model="searchRequest.dbs" :options="dbList" :settings="{ minimumResultsForSearch: Infinity, width: '100%', placeholder: $t('Form.select') }">
              </Select2>
            </dd>
            <dt>{{ $t("Form.id") }}</dt>
            <dd>
              <input class="g-input" type="text" v-model="searchRequest.id">
            </dd>
            <dt>{{ $t("Form.name") }}</dt>
            <dd>
              <input class="g-input" type="text" v-model="searchRequest.name">
            </dd>
            <dt>{{ $t("Form.age") }}</dt>
            <dd>
              <input class="g-input" type="text" v-model="searchRequest.age">
            </dd>
            <dt>{{ $t("Form.area") }}</dt>
            <dd>
              <input class="g-input" type="text" v-model="searchRequest.area">
            </dd>
            <dt>{{ $t("Form.nation") }}</dt>
            <dd>
              <input class="g-input" type="text" v-model="searchRequest.nation">
            </dd>
            <dt>{{ $t("Form.owc") }}</dt>
            <dd>
              <input class="g-input" type="text" v-model="searchRequest.owc">
            </dd>
            <dt>{{ $t("Form.ocm") }}</dt>
            <dd>
              <input class="g-input" type="text" v-model="searchRequest.ocm">
            </dd>
            <dt>{{ $t("Form.fyear") }}</dt>
            <dd>
              <input class="g-input" type="text" v-model="searchRequest.fyear">
            </dd>
          </dl>
          <div class="buttonArea">
            <button class="g-btn g-btn-xl g-btn-search" type="submit">{{ $t("Form.submit_search") }}</button>
            <button class="g-btn g-btn-reset" type="reset">{{ $t("Form.reset_search") }}</button>
          </div>
          <div class="buttonArea">
            <Select2 v-model="limit" :options="limit_options" :settings="{ minimumResultsForSearch: Infinity, width: '120px' }" :aria-label="$t('Form.change_limit')">
            </Select2>
          </div>
        </form>
      </section>
      <section class="block rensou">
        <h2 class="block_h">
          <i class="g-i g-i-search" aria-hidden="true"></i>
          <span class="g-clip">{{ $t("Home.rensou_header") }}</span>
          <img class="g-pc" :src="this.$i18n.locale == 'en' ? '/img/h-rensou-en.svg' : '/img/h-rensou.svg'" :width="this.$i18n.locale == 'en' ? 294 : 128" alt="">
          <img class="g-sp" :src="this.$i18n.locale == 'en' ? '/img/h-rensou-en.png' : '/img/h-rensou.png'" alt="">
        </h2>
        <form class="block_body" @submit.prevent="rensouObject">
          <div class="rensou_ta">
            <textarea class="g-textarea g-textarea-lg" cols="30" rows="3" :placeholder="$t('Form.rensou_placeholder')" v-model="rensouRequest.freetext"></textarea>
          </div>
          <div class="buttonArea">
            <button class="g-btn g-btn-xl g-btn-rensou" type="submit">{{ $t("Form.submit_search") }}</button>
            <button class="g-btn g-btn-reset" type="reset">{{ $t("Form.reset_search") }}</button>
          </div>
          <div class="buttonArea">
            <Select2 v-model="limit" :options="limit_options" :settings="{ minimumResultsForSearch: Infinity, width: '120px' }" :aria-label="$t('Form.change_limit')">
            </Select2>
          </div>
        </form>
      </section>
      <section class="block about">
        <h2 class="block_h">
          <i class="g-i g-i-index" aria-hidden="true"></i>
          <span class="g-clip">{{ $t("Site.others_header") }}</span>
          <img class="g-pc" :src="this.$i18n.locale == 'en' ? '/img/h-about-en.svg' : '/img/h-about.svg'" :width="this.$i18n.locale == 'en' ? 278 : 101" alt="">
          <img class="g-sp" :src="this.$i18n.locale == 'en' ? '/img/h-about-en.png' : '/img/h-about.png'" alt="">
        </h2>
        <div class="block_body">
          <ul>
            <li><router-link class="g-btn" :to="this.$i18n.locale == 'en' ? '/en/about' : '/about'">{{ $t("Site.about_this_website") }}</router-link></li>
            <li><router-link class="g-btn" :to="this.$i18n.locale == 'en' ? '/en/link' : '/link'">{{ $t("Site.links") }}</router-link></li>
          </ul>
        </div>
      </section>
      <section class="block news">
        <h2 class="block_h">
          <span class="g-clip">{{ $t("Home.notice") }}</span>
          <img class="g-pc" :src="this.$i18n.locale == 'en' ? '/img/h-news-en.svg' : '/img/h-news.svg'" width="125" alt="">
          <img class="g-sp" :src="this.$i18n.locale == 'en' ? '/img/h-news-en.png' : '/img/h-news.png'" alt="">
        </h2>
        <div class="block_body">
          <dl>
            <template v-for="(notice, index) in this.noticeList">
              <dt :key="'dt'+index">{{ notice.date }}</dt>
              <dd :key="'dd'+index">{{ notice.text }}</dd>
            </template>
          </dl>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import topicListJson from '@/assets/topicList.json'
import noticeListJson from '@/assets/noticeList.json'

import indexList from '@/components/indexList.vue'
import mainMixin from '@/mixins/mainMixin.js'
import i18n from '@/i18n.js'
import Select2 from 'v-select2-component';
import { directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'Home',
  mixins: [ mainMixin ],
  components: {
    Select2,
    indexList
  },
  directives: {
    swiper: directive
  },
  props: {
    dbList: { type: Array, required: true },
    indexList: { type: Array, required: true },
    listLimit: { type: Array, required: true },
  },
  data: function () {
    return {
      topicListAll: topicListJson,
      noticeListAll: noticeListJson,
      searchRequest: {
        fulltext: '',
        dbs: [],
        id: '',
        name: '',
        age: '',
        area: '',
        nation: '',
        owc: '',
        ocm: '',
        fyear: '',
        sort: 'id',
        order: 'asc'
      },
      rensouRequest: {
        freetext: '',
        ids: [],
      },
      limit: 25,
      swiperOption: {
        slidesPerView: 2.8,
        spaceBetween: 5,
        navigation: {
          nextEl: '.areaListArea_next',
          prevEl: '.areaListArea_prev'
        },
        breakpoints: {
          768: {
            slidesPerView: 5
          }
        }
      }
    }
  },
  filters: {
    // 英語ページの場合は英語ページへのリンクにする
    lang (path) {
      return i18n.locale == 'en' ? '/en'+path : path
    }
  },
  computed: {
    // プロジェクトから探すのリスト
    topicList () {
      return i18n.locale == 'en' ? this.topicListAll.en : this.topicListAll.ja
    },
    // お知らせのリスト
    noticeList () {
      return i18n.locale == 'en' ? this.noticeListAll.en : this.noticeListAll.ja
    },
    // 検索結果一覧の表示数選択セレクトボックス用
    limit_options: function() {
      const options = []
      this.listLimit.forEach(function (limit) {
        options.push({id:limit, text:i18n.t("Form.display_count", { count: limit })})
      });
      return options
    },
  },
  methods: {
    // 一致検索の実行
    searchObject() {
      const request = this.searchRequest
      request.lang = i18n.locale
      request.limit = this.limit
      request.page = 1

      // 空のプロパティを削除
      for(let i in request) {
        if(request[i] === "" || request[i] === []){
          delete request[i];
        }
      }
      if (i18n.locale == 'en') {
        this.$router.push({ path: '/en/search', query: request })
      } else {
        this.$router.push({ path: '/search', query: request })
      }
    },
    // 連想検索の実行
    rensouObject() {
      const request = this.rensouRequest
      request.lang = i18n.locale
      request.limit = this.limit
      request.page = 1
      if (i18n.locale == 'en') {
        this.$router.push({ path: '/en/search', query: request })
      } else {
        this.$router.push({ path: '/search', query: request })
      }
    },
  },
  head: {
    title: function () {
      return {
        inner: i18n.t('Site.title') + ' ' + i18n.t('Site.home'),
      }
    },
    meta: function () {
      return [
        { property: 'og:title', content: i18n.t('Site.title') + ' ' + i18n.t('Site.home') },
      ]
    }
  }
}
</script>

<style>
  @import "/css/T-01.css";
  @import "/css/select2.css";
</style>
